module.exports = "/_next/static/images/video_id_7118943592948731179-69d93e9c93609ecbbbc7c5a55500a381.jpg";